import { c as _c } from "react/compiler-runtime";
import { PortableText, type PortableTextBlock } from "next-sanity";
import { Separator } from "@repo/ui/separator";
import { Button } from "@repo/ui/button";
import { FeatureCards } from "@/components/navigation/cards";
import { MenuItemLink } from "@/components/navigation/menu-item-link.component";
import { ActionLink } from "@/components/common/actions/actions.component";
import type { RichMenuItem } from "@/components/navigation/navigation.types";
import { getI18nString } from "@/lib/utils";
interface RichMenuDropdownProps {
  menu: RichMenuItem;
  /** Shared height applied so every mega menu matches the tallest one. */
  minHeight?: number;
}
export function RichMenuDropdown(t0) {
  const $ = _c(26);
  const {
    menu,
    minHeight
  } = t0;
  const {
    bodyCopy,
    menuItems,
    featureCardsLayout
  } = menu;
  const cta = menu.actions?.[0];
  let t1;
  if ($[0] !== minHeight) {
    t1 = minHeight ? {
      minHeight
    } : undefined;
    $[0] = minHeight;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== menu.heading) {
    t2 = <h2 className="typography-desktop-heading-h5-voyage text-text-primary">{menu.heading}</h2>;
    $[2] = menu.heading;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== bodyCopy) {
    t3 = bodyCopy && <div className="typography-body-sm-season desktop:typography-body-md-season text-text-secondary"><PortableText value={bodyCopy as PortableTextBlock[]} /></div>;
    $[4] = bodyCopy;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== cta) {
    t4 = cta?.to && <ActionLink actionTo={cta.to} className="mt-2 w-fit"><Button variant="blue-filled" size="sm" asChild={true}><span>{getI18nString(cta.text, "Learn more")}</span></Button></ActionLink>;
    $[6] = cta;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = <div className="col-span-3 flex flex-col gap-4">{t2}{t3}{t4}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="col-span-1 flex justify-center"><Separator orientation="vertical" /></div>;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== menu.colour || $[14] !== menuItems) {
    t7 = menuItems && menuItems.map(item => <li key={item._key}><MenuItemLink item={item} colour={menu.colour} /></li>);
    $[13] = menu.colour;
    $[14] = menuItems;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <div className="col-span-3"><ul className="flex flex-col gap-y-4">{t7}</ul></div>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== featureCardsLayout || $[19] !== menu.colour) {
    t9 = featureCardsLayout && <><div className="col-span-1 flex justify-center"><Separator orientation="vertical" /></div><div className="col-span-4"><FeatureCards layout={featureCardsLayout} colour={menu.colour} /></div></>;
    $[18] = featureCardsLayout;
    $[19] = menu.colour;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t1 || $[22] !== t5 || $[23] !== t8 || $[24] !== t9) {
    t10 = <div className="container-grid py-12 min-h-[149px]" style={t1}>{t5}{t6}{t8}{t9}</div>;
    $[21] = t1;
    $[22] = t5;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}